import { h, render } from 'preact';
import picostyle from 'picostyle';

const style = picostyle(h);

export const Title = style('p')({
  marginTop: '0px',
  marginBottom: '10px !important',
  color: 'rgba(0, 0, 0, 0.75)',
  fontSize: 'inherit',
  lineHeight: '1.6',
});

export const InputGroup = style('div')(props => ({
  display: 'flex',
  marginTop: '0px',
  marginBottom: '0px',
  paddingTop: '3px',
  paddingBottom: '3px',
  paddingLeft: '0',
  alignItems: 'center',
  color: props.disabled ? 'rgba(0, 0, 0, 0.45)' : 'rgba(0, 0, 0, 0.75)',
  fontSize: 'inherit',
  lineHeight: '1.6'
}));

export const Input = style('input')({
  margin: '0'
});

export const Label = style('span')({
  marginLeft: '10px',
  fontSize: 'inherit',
  fontWeight: 'normal'
});
